import { useBpIntlModule } from '@beeline.com/bp-intl';
import messages from './rsi.intl.json';

export function useRsiIntl() {
  return useBpIntlModule(messages);
}
